/**
 * VirtualOffice (API)
 * VirtualOffice 関連のAPI
 */
import session from './session'

var uri = process.env.API_ENDPOINT

export default {
  // VirtualOffice API
  createVirtualOffice (data) {
    return session.post(uri + '/api/vo/virtual_office/', data)
  },
  getVirtualOffice (id) {
    if (id) return session.get(uri + '/api/vo/virtual_office/' + id)
    else return session.get(uri + '/api/vo/virtual_office/')
  },
  updateVirtualOffice (data) {
    return session.patch(uri + '/api/vo/virtual_office/' + data.pk, data)
  },
  deleteVirtualOffice (id) {
    return session.delete(uri + '/api/vo/virtual_office/' + id)
  },
  // OfficeType API
  createOfficeType (data) {
    return session.post(uri + '/api/vo/office_type/', data)
  },
  getOfficeType (id) {
    if (id) return session.get(uri + '/api/vo/office_type/' + id)
    else return session.get(uri + '/api/vo/office_type/')
  },
  updateOfficeType (data) {
    return session.patch(uri + '/api/vo/office_type/' + data.pk, data)
  },
  deleteOfficeType (id) {
    return session.delete(uri + '/api/vo/office_type/' + id)
  },
  // VirtualOfficeRoom API
  createVirtualOfficeRoom (data) {
    return session.post(uri + '/api/vo/virtual_office_room/', data)
  },
  getVirtualOfficeRoom (id) {
    if (id) return session.get(uri + '/api/vo/virtual_office_room/' + id)
    else return session.get(uri + '/api/vo/virtual_office_room/')
  },
  updateVirtualOfficeRoom (data) {
    return session.patch(uri + '/api/vo/virtual_office_room/' + data.pk, data)
  },
  deleteVirtualOffice (id) {
    return session.delete(uri + '/api/vo/virtual_office_room/' + id)
  },
  // TableName API
  createTableName (data) {
    return session.post(uri + '/api/vo/table_name/', data)
  },
  getTableName (id) {
    if (id) return session.get(uri + '/api/vo/table_name/' + id)
    else return session.get(uri + '/api/vo/table_name/')
  },
  updateTableName (data) {
    return session.patch(uri + '/api/vo/table_name/' + data.pk, data)
  },
  deleteTableName (id) {
    return session.delete(uri + '/api/vo/table_name/' + id)
  },
  // InitVirtualOffice
  initVirtualOffice (data) {
    return session.post(uri + '/api/vo/init_vo/', data)
  },
  // ChatRoom API
  createChatRoom (data) {
    return session.post(uri + '/api/vo/chat_room/', data)
  },
  getChatRoom (id) {
    if (id) return session.get(uri + '/api/vo/chat_room/' + id)
    else return session.get(uri + '/api/vo/chat_room/')
  },
  updateChatRoom (data) {
    return session.patch(uri + '/api/vo/chat_room/' + data.pk, data)
  },
  deleteChatRoom (id) {
    return session.delete(uri + '/api/vo/chat_room/' + id)
  },
  // ChatRoomMessage API
  getChatRoomMessage (id) {
    if (id) return session.get(uri + '/api/vo/chat_room_message/' + id)
    else return session.get(uri + '/api/vo/chat_room_message/')
  },
  //Forum API
  getForum (id) {
    if (id) return session.get(uri + '/api/vo/forum/' + id)
    else return session.get(uri + '/api/vo/forum/')
  },
  updateForum (data) {
    return session.patch(uri + '/api/vo/forum/' + data.id, data)
  },
  // Article API
  getArticle (id) {
    if (id) return session.get(uri + '/api/vo/article/' + id)
    else return session.get(uri + '/api/vo/article/')
  },
  createArticle (data) {
    return session.post(uri + '/api/vo/article/', data)
  },
  updateArticle (data) {
    return session.patch(uri + '/api/vo/article/' + data.id, data)
  },
  deleteArticle (id) {
    return session.delete(uri + '/api/vo/article/' + id)
  }
}


// WEBPACK FOOTER //
// ./src/api/virtualOffice.js